
import {Component, Vue} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {abstractField} from "vue-form-generator";
import SearchContactComponent from "@/components/contact/SearchContactComponent.vue";

@Component({
  components: {SearchContactComponent}
})
export default class SearchContactField extends mixins(Vue, abstractField) {

}
